import RegionsPageView from './RegionsPageView';

export default RegionsPageView;
